import { render } from "./PageScroller.vue?vue&type=template&id=3295d7c4"
import script from "./PageScroller.vue?vue&type=script&lang=js"
export * from "./PageScroller.vue?vue&type=script&lang=js"

import "./PageScroller.vue?vue&type=style&index=0&id=3295d7c4&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__